import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelsProductsGet } from '@/entities/parcels-products/modules/api/products';

export const useParcelProducts = (parcelId: string | undefined) =>
  useFetch({
    api: () => apiParcelsProductsGet(parcelId ?? ''),
    keywords: queryKeys.parcels.products(parcelId ?? ''),
    enabled: Boolean(parcelId),
    staleTime: 30_000,
  });
